import React from 'react';
import { Phone } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-brandBlue-600 text-white text-center" data-id="element-1252">
      <div className="max-w-3xl mx-auto" data-id="element-1253">
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-6" data-id="element-1254">
          Need Home Glass Repaired or Replaced?
        </h2>
        <p className="text-xl text-brandBlue-100 mb-8 leading-relaxed" data-id="element-1255">
          Do not let broken window glass, foggy insulated glass, damaged door
          glass or custom home glass projects linger. Request a free in-home
          estimate from Kosin's Glass and get clear guidance from a local
          residential glass expert.
        </p>
        <p className="text-sm font-semibold uppercase tracking-wider text-brandBlue-100/90 mb-8" data-id="element-1256">
          Trusted by Southeast Michigan homeowners for broken window repair,
          foggy glass, door glass and custom residential glass.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-1257">
          <a href="#estimate-form" className="w-full sm:w-auto bg-white text-brandBlue-700 hover:bg-slate-50 font-bold text-lg py-4 px-8 rounded-xl transition-colors shadow-lg" data-id="element-1258">
            Request a Free In-Home Estimate
          </a>
          <a href="tel:5175457772" className="w-full sm:w-auto bg-brandBlue-700 hover:bg-brandBlue-800 text-white border border-brandBlue-500 font-bold text-lg py-4 px-8 rounded-xl transition-colors flex items-center justify-center gap-2" data-id="element-1259">
            <Phone className="w-5 h-5" aria-hidden="true" data-id="element-1260" />
            Call 517-545-7772
          </a>
        </div>
      </div>
    </section>;
}